<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="none" style="overflow-x: hidden;">
    <v-card>
        <v-layout text-xs-center>
          <v-flex mb-0 xs12 mx-2>
            <v-layout justify-start row mx-3 mt-3 mb-0 align-center>
              <v-flex>
                <v-layout row>
                  <div
                    class="text-xs-left"
                    style="font-size: 20px; font-weight: 600;"
                  >Audit Log Details for {{auditLogDetails.AccountName}}</div>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row>
                  <v-flex>
                    <v-layout class="buttons mb-0 mr-0" justify-end align-top row>
                      <v-btn icon @click="cancel" class="pa-0 ma-0">
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout mx-3>
                <v-flex>
            <v-layout row>
                  <div
                    class="text-xs-left"
                    style="font-size: 20px; font-weight: 600;"
                  >Account #{{auditLogDetails.AccountNumber}}</div>
                </v-layout>
                <v-layout row v-if="auditLogDetails.ServiceId !==null">
                  <div
                    class="text-xs-left"
                    style="font-size: 20px; font-weight: 600;"
                  >{{"Service Identifier: "+ auditLogDetails.ServiceId}}</div>
                </v-layout>
                
                <v-layout>
                  <div
                    class="text-xs-left mt-2"
                    style="font-size: 18px;"
                  >Timestamp: {{auditLogDetails.LogTimestamp| formatDateTime}}</div>
                </v-layout>
                <v-layout>
                  <div
                    class="text-xs-left"
                    style="font-size:18px;"
                  >Modified by: {{auditLogDetails.ModifiedBy}}</div>
                </v-layout>
                </v-flex>
            </v-layout>
            <v-divider class="my-3"></v-divider>
            <v-list>
                <v-list-tile
                v-for="auditLogDetail in auditLogDetails.LogDetails"
                :key="auditLogDetail.ACCOLUMNNAME"
                style="height:30px"
                >
                <v-list-tile-content>
                    <v-layout row>
                    <v-flex class="font-weight-bold">{{auditLogDetail.ACCOLUMNNAME}}</v-flex> <v-flex>&nbsp;changed from&nbsp;</v-flex> <v-flex class="font-weight-bold"> {{auditLogDetail.ACOLDVALUE}} </v-flex><v-flex>&nbsp;to&nbsp;</v-flex><v-flex class="font-weight-bold"> {{auditLogDetail.ACNEWVALUE}} </v-flex> </v-layout>
            </v-list-tile-content>
                </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
    </v-card>
  </v-dialog>
</template>
<script>
 
  import axios from "axios";
  import moment from "moment"

  export default {
    name: "LogDetails",

    components: {
    },

    data: () => ({
      dialog: false,
      search: "",
      loading: true,

      showResetBtn: false,

      filters: {},
       auditLogDetails: [],
      filteredAuditLogs: [],
      BAN:{},
      type:null,
      
      role_id: null,

    }),

    watch: {
      dialog(val) {
        val || this.close();
      }
    },

filters:{
    formatDateTime:function(date){
        if (moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid()||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid()||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid()||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()){
            return moment(date, "YYYY-MM-DDTHH:mm:ss").format("YYYY/MM/DD h:mm:ss A")
        }
    }
},

    methods: {
      async initialize() {
        
      },

      // Get data for elements in component from response data props
    async getElementData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },

    // Get data for props of elements
    async getPropData(url, obj, prop) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`][`${prop}`] = resp.data))
        .catch(err => console.log(err));
    },

    // Get data for elements in component from response data
    async getResponseData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data))
        .catch(err => console.log(err));
    },

    async openAccountAuditLogDetails(item) {
        var ACSTAT = item
        this.type ="Account"
        this.dialog = true;
        this.getResponseData("api/AuditLogs/GetAccountAuditLogDetails/"+ACSTAT,"auditLogDetails")
    },
    async openServiceAuditLogDetails(item) {
        var ACSTAT = item
        this.type ="Service"
        this.dialog = true;
        this.getResponseData("api/AuditLogs/GetServiceAuditLogDetails/"+ACSTAT,"auditLogDetails")
    },
    async openChargeAuditLogDetails(item) {
        var ACSTAT = item
        this.type ="Charge"
        this.dialog = true;
        this.getResponseData("api/AuditLogs/GetChargeAuditLogDetails/"+ACSTAT,"auditLogDetails")
    },

    cancel() {
      this.dialog = false;
        
    //   this.resetFormFilters()
    },
    }
  };

</script>

<style scoped>
  table.v-table tbody td,
  table.v-table tbody th {
    height: 22px;
    font-size: 14px;
  }

  table.v-table tbody th {
    background-color: #4caf50;
  }

  table.v-table tbody tr:not(:last-child) {
    height: 22px;
    font-size: 14px;
  }
  .TierButton {
    border-color: #4caf50 !important;
    border-width: 1px !important;
    border-style: solid !important;
    color: #4caf50 !important;
    box-shadow: none !important;
    background-color: transparent !important;
  }
  .TierButton:hover {
    background-color: #4caf50 !important;
    color: white !important;
  }
</style>
